import { useState, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  activeCount?: number;
  title?: string;
}

export function FilterBar({ children, activeCount, title = 'Filtros' }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Mobile: collapsible */}
      <div className="md:hidden">
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          className="w-full flex items-center justify-between gap-2 px-3 py-2.5 bg-white border border-slate-200 rounded-md text-sm"
          aria-expanded={open}
        >
          <span className="flex items-center gap-2">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
            </svg>
            <span className="font-medium">{title}</span>
            {activeCount !== undefined && activeCount > 0 && (
              <span className="pill bg-brand-500 text-slate-900">{activeCount}</span>
            )}
          </span>
          <svg
            width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
            className={`text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`}
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
        {open && (
          <div className="mt-2 p-3 bg-white border border-slate-200 rounded-md grid grid-cols-1 gap-3">
            {children}
          </div>
        )}
      </div>

      {/* Desktop: inline flex row */}
      <div className="hidden md:flex flex-wrap items-end gap-3">
        {children}
      </div>
    </>
  );
}
